(function () {
    'use strict';

    angular.module('soopkitchenApp').controller('RenamePlanController', RenamePlanController);

    RenamePlanController.$inject = ['$uibModalInstance', 'parameters', 'SoopkitchenUtils', 'Planning', 'PlanTypes'];
    
    function RenamePlanController($uibModalInstance, parameters, SoopkitchenUtils, Planning, PlanTypes) {

        var vm = this;
        vm.planType = parameters.planType;
        vm.existingLabel = parameters.label;
        vm.newPlanLabel = '';
        
        vm.rename = rename;
        vm.clear = clear;

        function clear(status) {
            $uibModalInstance.dismiss(status);
        }

        function rename() {
            Planning.rename(
                {
                    planType: vm.planType,
                    planLabel: vm.existingLabel,
                    newPlanLabel: vm.newPlanLabel,
                },
                function successCallback(response) {
                    SoopkitchenUtils.invokeSweetAlert("Nice!", "You have renamed the plan " + vm.existingLabel + " to " + vm.newPlanLabel, "success", vm.clear('success'));
                },
                function errorCallback(response) {
                    SoopkitchenUtils.prettyError(response)
                }
            )
        }
    }
})();
